import { AiseaApiFactory } from "@/api/aisea/apiFactory";

export default {
  /**
   * 選択中のプロット情報を取得
   *
   * @param context
   * @param vesselId
   * @returns {*}
   */
  async fetch({ commit }, plotId) {
    let response = await AiseaApiFactory.get("plot").get(plotId)
    if(response.data.enterprise_id) {
      let res = await AiseaApiFactory.get("enterprisePublic").get(response.data.enterprise_id)

      response.data.provider = res.data;
    } else if(response.data.user_id) {
      let res = await AiseaApiFactory.get("userPublic").get(response.data.user_id)

      response.data.provider = res.data;
    }

    commit("CREATE", response.data)
  },
  /**
   * データ全削除
   *
   * @param context
   */
  clear: (context) => {
    context.commit("CLEAR");
  }
}
